import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SHOW_GLOBAL_LOADER } from '@shared/data-access/data-access-ui';
import { isDefined } from '@shared/utils/is-defined.utils';
import { map, Observable } from 'rxjs';

import { FilterTrainingDataRequest } from '../models/filter-training-data-request.model';
import {
  CreateTrainingTextRequest,
  PaginatedTrainingTextResponse,
  TrainingTextItem,
} from '../models/training-text-item.model';

@Injectable()
export class AiKnowledgeService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getTrainingData(payload: FilterTrainingDataRequest): Observable<TrainingTextItem[]> {
    let params = new HttpParams();

    if (isDefined(payload.pageNumber)) {
      params = params.set('pageNumber', payload.pageNumber);
    }

    if (payload.pageSize) {
      params = params.set('pageSize', payload.pageSize);
    }

    return this.http
      .get<PaginatedTrainingTextResponse>(`${this.baseUrl}/v1/machinelearning/training-data/texts`, {
        params,
        context: new HttpContext().set(SHOW_GLOBAL_LOADER, payload.enableGlobalLoader),
      })
      .pipe(map((response) => response.items));
  }

  createText(payload: CreateTrainingTextRequest): Observable<TrainingTextItem> {
    return this.http.post<TrainingTextItem>(`${this.baseUrl}/v1/machinelearning/training-data/texts`, payload, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }
}
